import { handleActions } from 'redux-actions';
import { loop, Cmd } from 'redux-loop';

import authActions from '../action/auth';
import wishListActions from '../action/wishList';
import { wishListAddCommand, wishListRemoveCommand } from '../command/wishList';

export { default as Actions } from '../action/wishList';

export const base = 'wishList';

export const defaultState = {
  entries: [],
  isLoading: false,
  needsFetch: true,
};

export const selectWishListIsLoading = ({ wishList }) => wishList.isLoading;
export const selectWishListNeedsFetch = ({ wishList }) => wishList.needsFetch;
export const selectWishListEntries = ({ wishList }) => wishList.entries;

export default () =>
  handleActions(
    {
      [wishListActions.add](state, { payload, meta }) {
        return loop(
          { ...state, isLoading: true },
          Cmd.run(wishListAddCommand, {
            successActionCreator: wishListActions.updateSuccess,
            args: [{ ...payload, entries: [...state.entries] }, meta.auth],
          })
        );
      },
      [wishListActions.remove](state, { payload, meta }) {
        return loop(
          { ...state, isLoading: true },
          Cmd.run(wishListRemoveCommand, {
            successActionCreator: wishListActions.updateSuccess,
            args: [{ ...payload, entries: [...state.entries] }, meta.auth],
          })
        );
      },
      [wishListActions.updateSuccess](state, { payload }) {
        return {
          ...state,
          entries: [...payload.entries],
          isLoading: false,
          needsFetch: false,
        };
      },
      [authActions.init](state) {
        return { ...state, isLoading: true };
      },
      [authActions.store](state, { payload }) {
        const { user } = payload;
        return {
          ...state,
          entries: user && user.wishlist ? user.wishlist : [],
          isLoading: false,
          needsFetch: false,
        };
      },
    },
    defaultState
  );
